import { createApi } from '@reduxjs/toolkit/query/react';
import customBaseQuery from '@/lib/customBaseQuery';

const palmettoBaseUrl = '/api/palmetto';
export const palmettoApi = createApi({
  reducerPath: 'palmettoApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getPalmettoUpdatedTracking: builder.query<string, ICounterParams>({
      query: (params) => ({
        url: `${palmettoBaseUrl}/updated-tracking`,
        params,
      }),
    }),
    savePalmettoResourceRequest: builder.mutation<
      PalmettoRRSaveResponse,
      PalmettoResourceRequestPayload
    >({
      query: (body) => ({
        url: `${palmettoBaseUrl}/resource-request`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useLazyGetPalmettoUpdatedTrackingQuery, useSavePalmettoResourceRequestMutation } =
  palmettoApi;
